import styles from './ModalComment.module.scss';
import { CrossIcon } from '../Icons/Cross';
import { FC, useCallback, MouseEventHandler, useRef } from 'react';
import clsx from 'clsx';

interface IModalCommentProps {
  comment: string;
  onClose?: () => void;
}
const ModalComment: FC<IModalCommentProps> = ({ comment, onClose }) => {
  const modal = useRef<HTMLDivElement>(null);
  const handleClose: MouseEventHandler<HTMLButtonElement> = useCallback(() => {
    onClose?.();
  }, [onClose]);

  return (
    <div className={clsx(styles.ModalComment)} ref={modal}>
      <div className={styles.comment_content}>
        <div className={styles.comment_header}>
          <h4>Комментарий</h4>
          <button className={styles.close_btn} onClick={handleClose}>
            <CrossIcon />
          </button>
        </div>
        <p>{comment}</p>
      </div>
    </div>
  );
};

export default ModalComment;
